module.exports = __webpack_public_path__ + "assets/1699ba995c3ffd3097a03834b2840d6a.png";